import {searchClient} from "@algolia/client-search";

const onitUrl = "https://portalepaziente.korian.it/PrenotazioneIntegrata/Index";

let originalMarkup = null;
const indexMap = {
	prestazioni: "dev_PRESTAZIONI",
	specialita: "dev_SPECIALITA",
	medici: "dev_MEDICI",
	convenzioni: "dev_CONVENZIONI",
	strutture: "dev_STRUTTURE",
	newseventi: "dev_NEWS",
	patologie: "dev_PATOLOGIE",
}

const ALGOLIA_APP_ID = "ID4NV3D7MX";
const ALGOLIA_API_KEY = "bba0365894b148136568abab52050283";

const getFiltersFromSession = () => {
	try {
		return JSON.parse(sessionStorage.getItem("activeFilters")) || [];
	} catch {
		return [];
	}
};

const saveFiltersToSession = (filters) => {
	sessionStorage.setItem("activeFilters", JSON.stringify(filters));
};

const algoliaFilter = () => {
	const dropdowns = document.querySelectorAll('.algolia-filters__dropdown');
	const filtersContainer = document.querySelector(".algolia-filters__main");
	const dropdownLists = document.querySelectorAll('.algolia-filters__dropdown-content');
	
	window.addEventListener("beforeunload", () => {
		sessionStorage.removeItem("activeFilters");
	});

	if (dropdowns) {
		dropdowns.forEach(dropdown => {
			let toggle = dropdown.querySelector('.algolia-filters__dropdown-toggle');
			const dropdownId = dropdown.dataset.dropdownId;
			const correspondingList = document.querySelector(`[data-dropdown-target="${dropdownId}"]`);
			let items = correspondingList ? correspondingList.querySelectorAll('li') : [];

			toggle.addEventListener('click', (e) => {
				const currentDropdown = e.target.closest('.algolia-filters__dropdown');
				
				if (currentDropdown.classList.contains('--active')) {
					// Chiudi il dropdown corrente
					currentDropdown.classList.remove('--active');
					if (correspondingList) {
						correspondingList.style.display = 'none';
					}
				} else {
					// Chiudi tutti gli altri dropdown
					dropdowns.forEach(dd => {
						dd.classList.remove('--active');
						const ddId = dd.dataset.dropdownId;
						const ddList = document.querySelector(`[data-dropdown-target="${ddId}"]`);
						if (ddList) {
							ddList.style.display = 'none';
						}
					});
					
					// Apri il dropdown corrente
					currentDropdown.classList.add('--active');
					if (correspondingList) {
						correspondingList.style.display = 'flex';
					}
				}
			});

			items.forEach(item => {
				item.addEventListener('click', (e) => {
					item.classList.add('--active');
					dropdown.classList.remove('--active');
					if (correspondingList) {
						correspondingList.style.display = 'none';
					}
				});
			});
		});

		// Chiudi dropdown quando clicchi fuori
		window.addEventListener('mouseup', function (e) {
			let isClickInsideDropdown = false;
			
			dropdowns.forEach(dropdown => {
				const dropdownId = dropdown.dataset.dropdownId;
				const correspondingList = document.querySelector(`[data-dropdown-target="${dropdownId}"]`);
				
				if (dropdown.contains(e.target) || (correspondingList && correspondingList.contains(e.target))) {
					isClickInsideDropdown = true;
				}
			});
			
			if (!isClickInsideDropdown) {
				dropdowns.forEach(dropdown => {
					dropdown.classList.remove('--active');
					const dropdownId = dropdown.dataset.dropdownId;
					const correspondingList = document.querySelector(`[data-dropdown-target="${dropdownId}"]`);
					if (correspondingList) {
						correspondingList.style.display = 'none';
					}
				});
			}
		});
	}


	if (filtersContainer) {
		filtersContainer.addEventListener('click', (e) => {
			const id = e.target.dataset.filterId || null;
			const cat = e.target.parentNode.dataset.filterCat || null;
			const searchInput = document.querySelector(".algolia-searchbox__input:not(.--main-search) input");

			if (id && cat && searchInput) {
				const keyword = searchInput.value;
				const entity = searchInput.dataset.entity;
				const specialityId = searchInput.dataset.specialityId;
				const plusServices = searchInput.dataset.servizi_plus;
				const region = searchInput.dataset.regione;
				const province = searchInput.dataset.provincia;
				const structureId = searchInput.dataset.struttura;
				const structureType = searchInput.dataset.tipologia;

				let filters = getFiltersFromSession();
				if (!filters.some(filter => filter.cat === cat && filter.id === id)) {
					filters.push({cat, id});
					saveFiltersToSession(filters);
				}

				updateFilterChips();

				performSearch(keyword, entity, specialityId, plusServices, region, province, structureId, structureType)
					.then(({hits, nbHits}) => {
						renderSearchResults(hits, keyword, null, entity, nbHits);
					});
			}
		});
	}
};

export const searchWithAlgolia = () => {
	const searchBar = document.querySelector('.algolia-searchbox__input:not(.--main-search)');

	if (searchBar) {
		const searchBox = searchBar.closest('.algolia-searchbox');
		const reset = searchBox.querySelector('.algolia-searchbox__reset');
		const false_submit = searchBox.querySelector('.algolia-searchbox__submit');

		searchBar.addEventListener('input', (e) => {
			const keyword = e.target.value;
			const entity = e.target.dataset.entity;
			const specialityId = e.target.dataset.specialityId;
			const plusServices = e.target.dataset.servizi_plus;
			const region = e.target.dataset.regione;
			const province = e.target.dataset.provincia;
			const structureId = e.target.dataset.struttura;
			const structureType = e.target.dataset.tipologia;
			const load_more = document.getElementById('load-more-ajax');

			if (keyword) {
				load_more?.classList.add('d-none');
				false_submit?.classList.add('opacity-0');
				reset?.classList.remove('d-none', 'pointer-events-none');
			} else {
				false_submit?.classList.remove('opacity-0');
				reset?.classList.add('d-none', 'pointer-events-none');
			}

			performSearch(keyword, entity, specialityId, plusServices, region, province, structureId, structureType)
				.then(({hits, nbHits}) => {
					const isSearchInStructurePage = !!structureId;
					renderSearchResults(hits, keyword, specialityId, entity, nbHits, isSearchInStructurePage);
				});
		});
		reset?.addEventListener('click', () => {
			searchBar.querySelector('input').value = '';
			false_submit.classList.remove('opacity-0');
			reset.classList.add('d-none', 'pointer-events-none');
			const keyword = searchBar.querySelector('input').value;
			const entity = searchBar.querySelector('input').dataset.entity;
			const specialityId = searchBar.querySelector('input').dataset.specialityId;
			const plusServices = searchBar.querySelector('input').dataset.servizi_plus;
			const region = searchBar.querySelector('input').dataset.regione;
			const province = searchBar.querySelector('input').dataset.provincia;
			const structureId = searchBar.querySelector('input').dataset.struttura;
			const structureType = searchBar.querySelector('input').dataset.tipologia;
			performSearch(keyword, entity, specialityId, plusServices, region, province, structureId, structureType)
				.then(({hits, nbHits}) => {
					renderSearchResults(hits, keyword, specialityId, entity, nbHits);
				});
		})
	}
};

// TODO: Questa funzione duplica buona parte del codice in searchWithAlgolia, sarebbe meglio separare la logica comune.
export const performSearchOnPageLoad = () => {
	// Check if the url has a query param called filter
	const url = new URL(window.location.href);
	const params = new URLSearchParams(url.search);

	if (!params.has('filter')) {
		return;
	}

	const searchBox = document.querySelector('.algolia-searchbox:has(.algolia-searchbox__input:not(.--main-search))');
	const searchBar = document.querySelector('.algolia-searchbox__input:not(.--main-search) input');
	const reset = searchBox.querySelector('.algolia-searchbox__reset');
	const false_submit = searchBox.querySelector('.algolia-searchbox__submit');
	const keyword = searchBar.value;
	const entity = searchBar.dataset.entity;
	const specialityId = searchBar.dataset.specialityId;
	const plusServices = searchBar.dataset.servizi_plus;
	const region = searchBar.dataset.regione;
	const province = searchBar.dataset.provincia;
	const structureId = searchBar.dataset.struttura;
	const structureType = searchBar.dataset.tipologia;
	const load_more = document.getElementById('load-more-ajax');

	if (keyword) {
		load_more?.classList.add('d-none');
		false_submit?.classList.add('opacity-0');
		reset?.classList.remove('d-none', 'pointer-events-none');
	} else {
		false_submit?.classList.remove('opacity-0');
		reset?.classList.add('d-none', 'pointer-events-none');
	}

	performSearch(keyword, entity, specialityId, plusServices, region, province, structureId, structureType)
		.then(({hits, nbHits}) => {
			renderSearchResults(hits, keyword, specialityId, entity, nbHits);
		});


}

export const globalSearchWithAlgolia = () => {
	const globalSearchBar = document.querySelector('.algolia-searchbox__input.--main-search');
	const searchBox = globalSearchBar.closest('.algolia-searchbox');
	const reset = searchBox.querySelector('.algolia-searchbox__reset');
	const searchResults = document.querySelector('.global-search__results');
	const searchFilters = document.querySelector('.global-search__filters');

	if (globalSearchBar) {
		globalSearchBar.addEventListener('input', (e) => {
			const keyword = e.target.value;

			if (keyword) {
				reset?.classList.remove('d-none', 'pointer-events-none');
				searchResults?.classList.remove('d-none');
				searchFilters?.classList.remove('d-none');
			} else {
				reset?.classList.add('d-none', 'pointer-events-none');
				searchResults?.classList.add('d-none');
				searchFilters?.classList.add('d-none');
			}

			performSearch(keyword, 'global')
				.then(({results}) => {
					let totalNumberOfResults = 0;
					results.forEach(resultsByIndex => {
						const {hits, index, nbHits} = resultsByIndex;

						totalNumberOfResults += nbHits;
						renderGlobalSearchResults(hits, index, nbHits);
					});

					const allResultsCounter = document.querySelector('.global-search__filters-list .global-search__filter:first-child .algolia-results-count');
					allResultsCounter.innerText = totalNumberOfResults;
				});
		})
		reset?.addEventListener('click', () => {
			globalSearchBar.querySelector('input').value = '';
			reset.classList.add('d-none', 'pointer-events-none');
			searchResults?.classList.add('d-none');
			searchFilters?.classList.add('d-none');
		})
	}
}

function performSearch(keyword, entity, specialityId = null, plusServices = null, region = null, province = null, structureId = null, structureType = null) {
	const client = searchClient(ALGOLIA_APP_ID, ALGOLIA_API_KEY);

	if (entity !== "global") {
		const searchParams = {
			query: keyword
		};

		const facetFilters = [];

		// Filtri dinamici dalla sessione
		const sessionFilters = getFiltersFromSession().map(({cat, id}) => `${cat}:${id}`);
		if (sessionFilters.length > 0) {
			facetFilters.push(...sessionFilters);
		}

		// Altri filtri statici
		if (specialityId) {
			facetFilters.push(`specialita:${specialityId}`);
		}
		if (plusServices) {
			facetFilters.push(`servizi_plus:${plusServices}`);
		}
		if (region) {
			facetFilters.push(`regione:${region}`);
		}
		if (province) {
			facetFilters.push(`provincia:${province}`);
		}
		if (structureId) {
			facetFilters.push(`strutture:${structureId}`);
		}
		if (structureType) {
			facetFilters.push(`tipologie:${structureType}`);
		}

		if (facetFilters.length > 0) {
			searchParams.facetFilters = facetFilters;
		}

		return client.searchSingleIndex({
			indexName: indexMap[entity],
			searchParams: searchParams
		});
	} else {
		const requests = [];
		for (const index in indexMap) {
			requests.push({
				indexName: indexMap[index],
				query: keyword,
				hitsPerPage: 12
			});
		}
		return client.search({requests});
	}
}


function renderGlobalSearchResults(hits, indexName, numberOfResults) {
	const globalSearchResultsSectionId = Object.keys(indexMap).filter((key) => indexMap[key] === indexName)[0];

	const filterLabel = document.querySelector(`.global-search__filter[data-filter="${globalSearchResultsSectionId}"]`);
	const filterLabelCounter = document.querySelector(`.global-search__filter[data-filter="${globalSearchResultsSectionId}"] .algolia-results-count`);
	if (filterLabelCounter) {
		if (numberOfResults === 0) {
			filterLabel.classList.add('d-none');
		} else {
			filterLabel.classList.remove('d-none');
			filterLabelCounter.innerText = numberOfResults
		}
	}

	const resultsSection = document.querySelector(`#${globalSearchResultsSectionId}`);
	
	if (resultsSection && numberOfResults === 0) {
		resultsSection.classList.add('d-none', '--noresults');
	} else if (resultsSection) {
		resultsSection.classList.remove('d-none');
	}
	if(resultsSection){
		const gotToLisBtn = resultsSection.querySelector('.gotToList');
		if (gotToLisBtn && numberOfResults > 12){
			gotToLisBtn.classList.remove('d-none');
		}else if (gotToLisBtn && numberOfResults <= 12){
			gotToLisBtn.classList.add('d-none');
		}
	}
	

	const filterTitleLabelCounter = document.querySelector(`#${globalSearchResultsSectionId} .algolia-results-count`);
	if (filterTitleLabelCounter) {
		filterTitleLabelCounter.innerText = numberOfResults === 0 ? "0 Risultati" : numberOfResults > 1 ? numberOfResults + " Risultati" : '1 Risultato';
	}


	if (globalSearchResultsSectionId) {

		if (globalSearchResultsSectionId === 'prestazioni' || globalSearchResultsSectionId === 'patologie') {
			const columnContainers = [];
			for (let i = 0; i < 3; i++) {
				const columnDiv = document.createElement('div');
				columnDiv.classList.add('col-lg-4');

				const resultsDiv = document.createElement('div');
				resultsDiv.classList.add('global-search__grid-results');

				columnDiv.appendChild(resultsDiv);
				columnContainers.push(resultsDiv);
			}


			hits.forEach((hit, index) => {

				const component = `<a href="${hit.url}" class="fw-bold text-site-primary">${hit.name} <i class="icon-arrow-right ms-2"></i></a>`;

				const columnIndex = index % 3;
				columnContainers[columnIndex].innerHTML += component;

			})

			const resultsContainer = document.querySelector(`#${globalSearchResultsSectionId} .row.gy-3`);
			resultsContainer.innerHTML = '';
			columnContainers.forEach(columnDiv => {
				// Aggiungi direttamente il div dei risultati (columnDiv.parentNode) al contenitore principale
				resultsContainer.appendChild(columnDiv.parentNode);
			});
		} else if (globalSearchResultsSectionId === 'strutture') {
			let component = '';
			hits.forEach((hit) => {
				var hide_address = hit?.hide_address;
				var provincia = hit?.provincia_short ? ' (' + hit?.provincia_short + ')' : "";
				var zona = hit?.zone ? ', ' + hit?.zone : "";
				component += `
					<div class="swiper-slide showMoreItem " data-group="search-strutture">
						<article class="card-struttura d-flex flex-column h-100" itemprop="itemListElement" itemscope="" itemtype="https://schema.org/ListItem">
						<figure class="card-struttura__thumb m-0 flex-shink-0 position-relative ">
							<a itemprop="url" href="${hit?.url}" class="h-100 w-100 d-block">
								<img class="w-100 obj-cover" loading="lazy" src="${hit?.photo}" alt="${hit?.name}">
							</a>
							<div class="card-struttura__label d-flex flex-wrap">
								${hit?.tipologie.length > 0 ? hit?.tipologie.map(item => `<span>${window.tipologie_json[item] || item}</span>`).join('') : ''}
							</div>
						</figure>
						<div class="card-struttura__content py-3 px-2 pb-0 bg-white d-flex flex-column justify-content-between align-items-center flex-grow-1 gap-3">
							<div class="card-struttura__info text-center w-100">

								<div class="card-struttura__title desc-1 libre-700 mt-2">
									<a class="text-site-primary d-block text-center lh-1 mb-1" href="${hit?.url}" itemprop="name">
										${hit?.name}                </a>
								</div>
								${hide_address ? '' : `
								<div class="desc-2 card-struttura__address lh-1">
									<i class="icon-pin"></i>
									<span class="century-700">${hit?.citta}</span>${provincia}${zona}
								</div>
								`}
							</div>
							<div class="card-struttura__link text-center d-flex align-items-start justify-content-center">
								<a href="${hit?.url}" class="desc-3 text-decoration-underline">Vai alla scheda</a>
							</div>
						</div>
					</article>
				</div>`;
			});

			const resultsContainer = document.querySelector(`#${globalSearchResultsSectionId} .swiper-wrapper.grid_4`);
			resultsContainer.innerHTML = component;
		} else if (globalSearchResultsSectionId === 'medici') {
			let component = '';
			hits.forEach((hit) => {
				component += `
						<div class="swiper-slide showMoreItem " data-group="search-medici">
							<article class="d-flex align-items-center position-relative item-card --mini shadow-none bg-site-primary-light p-2">
								<div class="position-relative item-card__thumb flex-shrink-0 ratio ratio-1x1">
									<img class="rounded obj-cover bg-white" src="${hit.photo ? hit.photo : '/wp-content/themes/korian-master-theme/images/korian-logo-icon.svg'}" alt="${hit.name}">
								</div>
								<div class="ms-3">
									<a href="${hit.url}" class="desc-1 text-corporate century-700 d-block mb-1 stretched-link">${hit.name}</a>
									${hit.redazione && hit.redazione.length > 0 ? `<div class="desc-3 text-site-primary">
										${hit.redazione}
									</div>` : ''}
									${hit.ruolo && hit.ruolo.length > 0 ? `<div class="desc-3 text-site-primary">
										${hit.ruolo.join(', ')}
									</div>` : ''}
								</div>
							</article>
						</div>
					`
			});
			const resultsContainer = document.querySelector(`#${globalSearchResultsSectionId} .swiper-wrapper.grid_4`);
			resultsContainer.innerHTML = component;
		} else if (globalSearchResultsSectionId === 'newseventi') {
			let component = '';

			hits.forEach((hit) => {
				component += `
						<div class="swiper-slide">
							<div class="h-100 bg-site-primary-light rounded p-2">
								<article class="mostviewed-item text-decoration-none">
									<div class="d-flex gap-3 align-items-center">
										<figure class="mostviewed-item-figure overflow-hidden">
											<img src=${hit.photo} alt="${hit.name}">
										</figure>
										<div class="mostviewed-item-content">
											<a href="${hit.url}" class="mostviewed-item-title century-700 text-primary desc-2 lh-sm d-inline-block">
										${hit.name}</a>
										</div>
									</div>
								</article>
							</div>
						</div>
					`
			});

			const resultsContainer = document.querySelector(`#${globalSearchResultsSectionId} .swiper-wrapper.grid_3`);
			resultsContainer.innerHTML = component;

		}

	}


}

function renderSearchResults(hits, keyword, specialityId, entity, nbHits, isSearchInStructurePage = false) {
	let listHtml = "";

	const resultCounter = document.querySelector(".algolia-loop .text-end.algolia-results-count");
	if (resultCounter) {
		resultCounter.innerText = nbHits > 0 ? nbHits === 1 ? "1 Risultato" : nbHits + " Risultati" : "0 Risultati";
	}
	const load_more = document.getElementById('load-more-ajax');
	if (load_more) {
		load_more.classList.add('d-none');
	}

	if (hits.length > 0) {

		if (entity === "strutture" && window.eventMap) {
			// Regenerate marker with new one.
			window.eventMap.markers.forEach(marker => {
				marker.setMap(null);
			})
		}

		if (entity === "strutture") {
			filterStrutture(hits);
		} else if (entity === "convenzioni") {
			filterConvenzioni(hits);
		} else if (entity === "medici") {
			filterMedici(hits);
		}

		// Recupero i dati delle prestazioni dalla variabile globale window.prestazioniPulite
		let prestazioniPulite = window.prestazioniPulite || {};
		// Recupero i dati dei medici dalla variabile globale window.mediciPuliti
		let mediciPuliti = window.mediciPuliti || {};

		hits.forEach(hit => {
			const regex = new RegExp(keyword, 'gi');
			const hitName = hit?.name.replace(regex, `<span class="hl">${keyword}</span>`);
			let component = '';
			const svgIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28"><g id="Raggruppa_7071" data-name="Raggruppa 7071" transform="translate(-950.591 -24.114)"><g id="Ellisse_8" data-name="Ellisse 8" transform="translate(950.591 24.114)" fill="#fff" stroke="#00aac3" stroke-width="1"><circle cx="14" cy="14" r="14" stroke="none"/><circle cx="14" cy="14" r="13.5" fill="none"/></g><g id="Raggruppa_7069" data-name="Raggruppa 7069" transform="translate(957.178 31.936)"><g id="arrow-right-circle" transform="translate(13.77 12.05) rotate(180)"><g id="Raggruppa_6363" data-name="Raggruppa 6363" transform="translate(0)"><path id="Tracciato_1733" data-name="Tracciato 1733" d="M12.91,5.164a.861.861,0,0,1,0,1.721H2.939l3.7,3.693A.862.862,0,1,1,5.416,11.8L.253,6.634a.861.861,0,0,1,0-1.219L5.416.252A.862.862,0,0,1,6.635,1.471l-3.7,3.693Z" transform="translate(0 0)" fill="#00aac3" fill-rule="evenodd"/></g></g></g></g></svg>';
			if (specialityId || entity === "prestazioni" || entity === "patologie") {

				const pageUrl = window.location.href;
				const hitSlug = hit?.url?.replace("/prestazione/", "") || "";

				// Verifico se la prestazione è presente nei dati puliti
				// Verifica accurata del codice_onit
				let codice_onit = "";
				if (hit?.codice_onit) {
					codice_onit = hit.codice_onit;
				}

				let hitOnit = onitUrl + "?IdPrestazioneGruppo=" + codice_onit + "&IdAziendaGruppo=";
				let isPrenotabile = false;

				// Cerco una corrispondenza parziale se non trovo una corrispondenza esatta
				if (isSearchInStructurePage && codice_onit && !prestazioniPulite[codice_onit]) {
					const chiavi = Object.keys(prestazioniPulite);
					for (const chiave of chiavi) {
						if (chiave.includes(codice_onit) || codice_onit.includes(chiave)) {
							codice_onit = chiave;
							break;
						}
					}
				}

				if (codice_onit && prestazioniPulite[codice_onit]) {
					hitOnit = prestazioniPulite[codice_onit].url_prenotazione;
					isPrenotabile = prestazioniPulite[codice_onit].prenotabile;
				}

				if (isSearchInStructurePage) {
					component = `
					<article class="algolia-loop__item position-relative --prestazione bg-site-primary-light lh-1 gap-2" data-group="struttura-prestazioni">
						<a href="${pageUrl + hitSlug}" class="text-corporate algolia-loop__item-title century-700">${hitName}</a>
						<div class="flex-shrink-0 d-flex align-items-center gap-3">
							<a
							href="${hitOnit}"
							data-prestazione-code="${codice_onit}"
							target="_blank"
							class="cta --filled-rsa --small px-3 desc-3 onit-prenota-prestazione ${isPrenotabile ? '' : 'd-none'}"
							>Prenota</a>
							<a href="${pageUrl + hitSlug}" class="d-none d-lg-block">${svgIcon}</a>
						</div>
					</article>
					`;
				} else {
					component = `
					<article class="algolia-loop__item position-relative --prestazione bg-site-primary-light">
						<div class="algolia-loop__item-content">
						<div class="d-flex align-items-center gap-3 gap-lg-4">
							<div class="algolia-loop__item-info">
							<a href="${isSearchInStructurePage ? hit?.slug : hit?.url}" class="algolia-loop__item-title century-700 text-corporate desc-1 stretched-link text-decoration-none">${hitName}</a>
							</div>
						</div>
						</div>
						<div class="algolia-loop__item-side flex-shrink-0 d-none d-lg-block rounded-circle">${svgIcon}</i></div>
					</article>
					`;
				}

			} else if (entity === "specialita") {
				component = `
					<article class="algolia-loop__item position-relative --prestazione bg-site-primary-light">
						<div class="algolia-loop__item-content">
						<div class="d-flex align-items-center gap-3 gap-lg-4">
							<div class="algolia-loop__item-info">
							<a href="${isSearchInStructurePage ? hit?.slug : hit?.url}" class="algolia-loop__item-title century-700 text-corporate desc-1 stretched-link text-decoration-none">${hitName}</a>
							</div>
						</div>
						</div>
						<div class="algolia-loop__item-side flex-shrink-0 d-none d-lg-block rounded-circle">${svgIcon}</i></div>
					</article>
					`;
			} else if (entity === "strutture") {
				eventMap.markers.forEach(marker => {
					const lat = marker.getPosition().lat();
					const lng = marker.getPosition().lng();

					// Tolleranza in metri
					const tolerance = 1000;

					// Controlla se la distanza tra le due coordinate è inferiore alla tolleranza
					if (getDistanceFromLatLonInMeters(lat, lng, hit?.coordinate.lat, hit?.coordinate.lng) <= tolerance) {
						marker.setMap(eventMap);
					}
				});
				var hide_address = hit?.hide_address;
				var provincia = hit?.provincia_short ? ' (' + hit?.provincia_short + ')' : "";
				var zona = hit?.zone ? ', ' + hit?.zone : "";
				component = `
				<article class="card-struttura d-flex flex-column h-100" itemprop="itemListElement" itemscope="" itemtype="https://schema.org/ListItem">
				<figure class="card-struttura__thumb m-0 flex-shink-0 position-relative ">
					<a itemprop="url" href="${hit?.url}" class="h-100 w-100 d-block">
						<img class="w-100 obj-cover" loading="lazy" src="${hit?.photo}" alt="${hit?.name}">
					</a>
					<div class="card-struttura__label d-flex flex-wrap">
						${hit?.tipologie.length > 0 ? hit?.tipologie.map(item => `<span>${window.tipologie_json[item] || item}</span>`).join('') : ''}
					</div>
				</figure>
				<div class="card-struttura__content py-3 px-2 pb-0 bg-white d-flex flex-column justify-content-between align-items-center flex-grow-1 gap-3">
					<div class="card-struttura__info text-center w-100">

						<div class="card-struttura__title desc-1 libre-700 mt-2">
							<a class="text-site-primary d-block text-center lh-1 mb-1" href="${hit?.url}" itemprop="name">
								${hit?.name}                </a>
						</div>
						${hide_address ? '' : `
						<div class="desc-2 card-struttura__address lh-1">
							<i class="icon-pin"></i>
							<span class="century-700">${hit?.citta}</span>${provincia}${zona}
						</div>
						`}
					</div>
					<div class="card-struttura__link text-center d-flex align-items-start justify-content-center">
						<a href="${hit?.url}" class="desc-3 text-decoration-underline">Vai alla scheda</a>
					</div>
				</div>
			</article>
				`;
			} else if (entity === "medici") {
				// Gestione specifica per i medici
				const pageUrl = window.location.href;
				let hitSlug = hit?.url || "";
				let desc = "";
				if (hit?.redazione) {
					desc += hit.redazione;
				}
				if (hit?.ruolo && hit?.ruolo.length > 0) {
					if (desc) {
						desc += `, ${hit?.ruolo.join(', ')}`;
					} else {
						desc += hit?.ruolo.join(', ');
					}
				}

				// Verifico se il medico è presente nei dati puliti usando il CF
				let cf_medico = "";
				if (hit?.cf) {
					cf_medico = hit.cf;
				} else if (hit?.codice_fiscale) {
					cf_medico = hit.codice_fiscale;
				}

				let hitOnit = onitUrl + "?IdMedicoGruppo=&IdAziendaGruppo=";
				let isPrenotabile = false;
				let codice_medico = "";

				// Cerco una corrispondenza con il CF nei dati mediciPuliti
				if (isSearchInStructurePage && cf_medico) {
					if (mediciPuliti[cf_medico]) {
						hitOnit = mediciPuliti[cf_medico].url_prenotazione;
						isPrenotabile = mediciPuliti[cf_medico].prenotabile;
						codice_medico = mediciPuliti[cf_medico].codice;
					}
				}

				if (isSearchInStructurePage) {
					component = `
					<article class="algolia-loop__item position-relative --medico bg-site-primary-light lh-1 gap-2" data-group="struttura-medici">
						<div class="d-flex align-items-center gap-3">
							<figure class="algolia-loop__item-thumb flex-shrink-0 bg-white">
								<img class="aspect-1-1 obj-cover rounded-3" src="${hit?.photo || '/wp-content/themes/korian-master-theme/images/korian-logo-icon.svg'}" alt="${hit?.name}">
							</figure>
							<div>
								<a href="${hit?.url}" class="text-corporate algolia-loop__item-title century-700">${hitName}</a>
								<div class="algolia-loop__item-title text-site-primary desc-2">${desc}</div>
							</div>
						</div>
						<div class="flex-shrink-0 d-flex align-items-center gap-3">
							<a
							href="${hitOnit}"
							data-cf-medico="${cf_medico}"
							target="_blank"
							class="cta --filled-rsa --small px-3 desc-3 onit-prenota-link ${isPrenotabile ? '' : 'd-none'}"
							>Prenota</a>
							<a href="${hit?.url}" class="d-none d-lg-block">${svgIcon}</a>
						</div>
					</article>
					`;
				} else {
					component = `
					<article class="algolia-loop__item position-relative --medico bg-site-primary-light">
						<div class="algolia-loop__item-content">
							<div class="d-flex align-items-center gap-3 gap-lg-4">
								<figure class="algolia-loop__item-thumb flex-shrink-0 bg-white">
									<img class="aspect-1-1 obj-cover rounded-3" src="${hit?.photo || '/wp-content/themes/korian-master-theme/images/korian-logo-icon.svg'}" alt="${hit?.name}">
								</figure>
								<div class="algolia-loop__item-info">
									<a href="${isSearchInStructurePage ? hit?.slug : hit?.url}" class="algolia-loop__item-title century-700 text-corporate desc-1 stretched-link text-decoration-none">${hitName}</a>
									<div class="algolia-loop__item-title text-site-primary desc-2">${desc}</div>
								</div>
							</div>
						</div>
						<div class="algolia-loop__item-side flex-shrink-0 d-none d-lg-block rounded-circle pe-3">${svgIcon}</i></div>
					</article>
					`;
				}
			} else if (entity === "convenzioni") {
				const desc = hit?.formula[0];
				const imgClass = 'aspect-1-1 obj-contain p-2 rounded';
				component = `
				<article class="algolia-loop__item position-relative --medico bg-site-primary-light">
					<div class="algolia-loop__item-content">
						<div class="d-flex align-items-center gap-3 gap-lg-4">
							<figure class="algolia-loop__item-thumb flex-shrink-0 bg-white">
								<img class="${imgClass}" src="${hit?.photo}" alt="${hit?.name}">
							</figure>
							<div class="algolia-loop__item-info">
								<a href="${isSearchInStructurePage ? hit?.slug : hit?.url}" class="algolia-loop__item-title century-700 text-corporate desc-1 stretched-link text-decoration-none">${hitName}</a>
								<div class="algolia-loop__item-title text-site-primary desc-2">${desc}</div>
							</div>
						</div>
					</div>
					<div class="algolia-loop__item-side flex-shrink-0 d-none d-lg-block rounded-circle pe-3">${svgIcon}</i></div>
				</article>
				`;
			} else {
				// Gestione generica per altre entità
				component = `
				<article class="algolia-loop__item position-relative bg-site-primary-light">
					<div class="algolia-loop__item-content">
						<div class="d-flex align-items-center gap-3 gap-lg-4">
							<div class="algolia-loop__item-info">
								<a href="${isSearchInStructurePage ? hit?.slug : hit?.url}" class="algolia-loop__item-title century-700 text-corporate desc-1 stretched-link text-decoration-none">${hitName}</a>
							</div>
						</div>
					</div>
					<div class="algolia-loop__item-side flex-shrink-0 d-none d-lg-block rounded-circle">${svgIcon}</i></div>
				</article>
				`;
			}

			listHtml += component;
		});

		const list = document.querySelector(".algolia-loop__results");
		if (list) {
			if (!originalMarkup) {
				originalMarkup = list.innerHTML;
			}

			if (originalMarkup && keyword.length === 0) {
				list.innerHTML = originalMarkup;
			}
			list.innerHTML = listHtml;

			// Ordina gli elementi in base alla presenza del pulsante Prenota
			if(entity !== 'medici') {
				sortByBookableStatus('.algolia-loop__results');
			}
		}
	} else {
		const list = document.querySelector(".algolia-loop__results");
		if (list) {
			list.innerHTML = `<div style="grid-column: span 3;">Nessun risultato trovato. Prova a modificare i tuoi termini di ricerca o verifica che siano scritti correttamente.</div>`;
		}
	}
}

function updateFilterChips() {
	const activeFilters = sessionStorage.getItem("activeFilters");
	const activeFiltersContainer = document.querySelector(".algolia-filters__chips");
	let component = "";

	if (activeFilters) {
		let filters;
		try {
			filters = JSON.parse(activeFilters);
		} catch (e) {
			filters = [];
		}

		if (filters.length > 0) {
			filters.forEach(({cat, id}) => {
				const name = document.querySelector(`[data-filter-id="${id}"]`);
				if (name) {
					component += `
						<div class="algolia-filters__chips-item d-flex align-items-center gap-1">
							<div class="desc-2">${name.innerText}</div>
							<i class="icon-close" data-remove-id="${id}"></i>
						</div>
					`;
				}
			});
			activeFiltersContainer.innerHTML = component;
			activeFiltersContainer.classList.remove("d-none");
		} else {
			activeFiltersContainer.innerHTML = "";
			activeFiltersContainer.classList.add("d-none");
		}

		activeFiltersContainer.removeEventListener("click", handleFilterChipClick);
		activeFiltersContainer.addEventListener("click", handleFilterChipClick);
	} else {
		activeFiltersContainer.innerHTML = "";
		activeFiltersContainer.classList.add("d-none");
	}
}

function handleFilterChipClick(e) {
	if (e.target.classList.contains("icon-close")) {
		const removeId = e.target.dataset.removeId;
		let filters = getFiltersFromSession();
		const newActiveFilters = filters.filter(filter => filter.id !== removeId);

		if (newActiveFilters.length > 0) {
			saveFiltersToSession(newActiveFilters);
		} else {
			sessionStorage.removeItem("activeFilters");
		}

		const dropdownContent = document.querySelector(`.algolia-filters__dropdown-content li[data-filter-id="${removeId}"]`);
		if (dropdownContent) {
			dropdownContent.classList.remove('--active');
		}

		updateFilterChips();

		const searchInput = document.querySelector(".algolia-searchbox__input:not(.--main-search) input");
		if (searchInput) {
			const keyword = searchInput.value;
			const entity = searchInput.dataset.entity;
			const specialityId = searchInput.dataset.specialityId;
			const plusServices = searchInput.dataset.servizi_plus;
			const region = searchInput.dataset.regione;
			const structureId = searchInput.dataset.struttura;
			const province = searchInput.dataset.provincia;
			const structureType = searchInput.dataset.tipologia;

			performSearch(keyword, entity, specialityId, plusServices, region, province, structureId, structureType)
				.then(({hits, nbHits}) => {
					renderSearchResults(hits, keyword, null, entity, nbHits);
				});
		}
	}
}

// Aggiornamento voci filtri
function filterStrutture(hits) {
	const availableRegions = new Set();
	const availableProvinces = new Set();
	const availableSpecialities = new Set();
	const availablePerformances = new Set();

	hits.forEach(hit => {
		availableRegions.add(hit.regione);
		availableProvinces.add(hit.provincia);
		hit.specialita.forEach(specialita => availableSpecialities.add(specialita));
		hit.prestazioni.forEach(prestazione => availablePerformances.add(prestazione));
	});


	toggleFilterOptions('regione', availableRegions);
	toggleFilterOptions('provincia', availableProvinces);
	toggleFilterOptions('specialita', availableSpecialities);
	toggleFilterOptions('prestazioni', availablePerformances);
}

function filterConvenzioni(hits) {
	const availableStructures = new Set();
	const availableTypes = new Set();
	const availableFormulas = new Set();

	hits.forEach(hit => {
		hit.strutture.forEach(struttura => availableStructures.add(struttura));
		hit.tipologia.forEach(tipologia => availableTypes.add(tipologia));
		hit.formula.forEach(formula => availableFormulas.add(formula));
	});


	toggleFilterOptions('struttura', availableStructures);
	toggleFilterOptions('tipologia', availableTypes);
	toggleFilterOptions('formula', availableFormulas);
}

function filterMedici(hits) {
	const availableRoles = new Set();
	const availableSpecialities = new Set();
	const availableStructures = new Set();

	hits.forEach(hit => {
		hit.ruolo.forEach(ruolo => availableRoles.add(ruolo));
		hit.specialita.forEach(specialita => availableSpecialities.add(specialita));
		// hit.strutture.forEach(struttura => availableStructures.add(struttura));
	});


	toggleFilterOptions('ruolo', availableRoles);
	toggleFilterOptions('specialita', availableSpecialities);
	toggleFilterOptions('struttura', availableStructures);
}

function toggleFilterOptions(filterType, availableOptions) {
	const filterElements = document.querySelectorAll(`[data-filter-cat='${filterType}'] li`);

	filterElements.forEach(element => {
		element.classList.remove('d-none');
	});
	const optionslenght = availableOptions.size;
	filterElements.forEach(element => {
		const filterId = isNaN(parseInt(element.dataset.filterId)) ? element.dataset.filterId : parseInt(element.dataset.filterId);
		if (!availableOptions.has(filterId)) {
			element.classList.add('d-none');
		} else {
			element.classList.remove('d-none');
		}
		if (optionslenght == 0 && filterId == 0) {
			console.log('hiding element')
			element.classList.remove('d-none');
		}
	});
}


// Roba per Google Maps
function getDistanceFromLatLonInMeters(lat1, lon1, lat2, lon2) {
	const R = 6371000; // Raggio della Terra in metri
	const dLat = deg2rad(lat2 - lat1);
	const dLon = deg2rad(lon2 - lon1);
	const a =
		Math.sin(dLat / 2) * Math.sin(dLat / 2) +
		Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
		Math.sin(dLon / 2) * Math.sin(dLon / 2);
	const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
	// Distanza in metri
	return R * c;
}

// Funzione per convertire gradi in radianti
function deg2rad(deg) {
	return deg * (Math.PI / 180);
}

// Funzione per ordinare gli elementi in base alla presenza del pulsante Prenota
// e gestire la visibilità (max 12 elementi visibili)
function sortByBookableStatus(containerSelector) {
	const container = document.querySelector(containerSelector);
	if (!container) return;

	const items = Array.from(container.querySelectorAll('.algolia-loop__item'));
	if (items.length === 0) return;

	// Rimuovi la classe --hidden da tutti gli elementi
	items.forEach(item => {
		item.classList.remove('--hidden');
	});

	// Ordina gli elementi: prima quelli con pulsante di prenotazione visibile
	items.sort((a, b) => {
		// Cerca il pulsante di prenotazione utilizzando i selettori corretti:
		// - onit-prenota-prestazione per le prestazioni
		// - onit-prenota-link per i medici
		const bookButtonA = a.querySelector('.onit-prenota-prestazione:not(.d-none)') ||
			a.querySelector('.onit-prenota-link:not(.d-none)');
		const bookButtonB = b.querySelector('.onit-prenota-prestazione:not(.d-none)') ||
			b.querySelector('.onit-prenota-link:not(.d-none)');

		// Se A ha il pulsante visibile e B no, A viene prima
		if (bookButtonA && !bookButtonB) return -1;
		// Se B ha il pulsante visibile e A no, B viene prima
		if (!bookButtonA && bookButtonB) return 1;
		// Altrimenti mantiene l'ordine originale
		return 0;
	});

	// Ricostruisci il contenitore con gli elementi ordinati e gestisci la visibilità
	items.forEach((item, index) => {
		// Aggiungi la classe --hidden se l'indice è maggiore di 11 (primi 12 elementi visibili)
		if (index >= 12) {
			item.classList.add('--hidden');
		}
		container.appendChild(item);
	});
}

export default algoliaFilter;
